import { useContext } from "react";
import { ThemeContext } from "../components/ThemeProvider/ThemeProvider";
import { ThemeContextInterface } from "../interfaces/theme";

/**
 * Access the active theme and the controls to change it.
 *
 * @returns The theme context value.
 */
export const useTheme = (): ThemeContextInterface => {
  const context: ThemeContextInterface = useContext(ThemeContext);

  if (!context) {
    throw new Error("useTheme must be used within a ThemeProvider");
  }

  return context;
};
